import Button from '@components/Button';
import { CheckboxNoFunc } from '@components/Checkbox';
import { sendSuccess } from '@components/Noti';
import { uploadThumb } from '@modules/alioss';
import { onViewCaptured } from '@modules/player/actions/viewActions';
import { $sceneMapApi } from '@stores/dataStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import { $loadedScene } from '@stores/loadedStore';
import { $member } from '@stores/memberStores';
import { $viewMode } from '@stores/viewModeStores';
import { type GeneralID, MatrixFovType, SceneType } from '@types';
import dataURLtoFile from '@utils/dataURLtoFile';
import { thumbPrefix } from '@utils/prefixMaker';
import { useStore } from 'effector-react';
import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import ImgMobile from './img-block-mobile.png';
import ImgBlock from './img-block.png';

const round = (val: number) => Math.round(val * 1000) / 1000;

const upload = async (id: GeneralID, file: File) => {
  const memberData = $member.getState();
  const prefix = thumbPrefix({ memberData, sceneId: id });
  const url = await uploadThumb({ file, prefix });
  $sceneMapApi.update((draft) => {
    draft.get(id)!.thumbUrl = url;
  });
};

function ViewCaptureWidget() {
  const scene = useStore($loadedScene);
  const viewMode = useStore($viewMode);
  const [isOn, setIsOn] = useLocalStorage('capture-apply-to-scene', true);

  useEffect(() => {
    const unwatch = onViewCaptured.watch((dataUrl) => {
      if (scene?.id) {
        upload(scene.id, dataURLtoFile(dataUrl, 'capture.png'));
      }
    });
    return unwatch;
  }, [scene?.id]);

  if (!scene) return null;
  if (scene.type === SceneType.panoVideo) return null;
  if (
    scene.type === SceneType.matrix &&
    scene.view.flatFovType === MatrixFovType.fullscreen
  ) {
    return null;
  }

  const handleCapture = () => {
    const view = MainPlayer.get()?.getView();
    if (!view) return;
    $sceneMapApi.update((draft) => {
      draft.get(scene.id)!.view.fov = round(view.fov);
      draft.get(scene.id)!.view.hLookAt = round(view.hlookat);
      draft.get(scene.id)!.view.vLookAt = round(view.vlookat);
    });
    if (isOn) {
      MainPlayer.get()?.makeSnapshot();
    }
    sendSuccess('设置成功');
  };

  return (
    <>
      {viewMode === 'pc' && (
        <img
          src={ImgBlock}
          draggable={false}
          className="pointer-events-none absolute"
          style={{ width: 704, height: 404 }}
          alt=""
        />
      )}
      {viewMode === 'mobile' && (
        <img
          src={ImgMobile}
          draggable={false}
          className="pointer-events-none absolute"
          style={{ width: 260, height: 400 }}
          alt=""
        />
      )}
      <div className="absolute flex flex-col items-center translate-y-150">
        <div
          className="px-10 py-5 bg-[#000000]/50 rounded flex items-center select-none"
          onClick={() => {
            setIsOn(!isOn);
          }}
        >
          <CheckboxNoFunc className="mr-5" checked={isOn} />
          同时设置为场景封面
        </div>
        <Button className="mt-10" onClick={handleCapture}>
          把当前视角设为初始视角
        </Button>
      </div>
    </>
  );
}

export default ViewCaptureWidget;
